import React from "react";
import {
  SectionWrap,
  TraderDetailBackground,
  TraderDetailSection,
} from "./styles";
import TraderDetailRightSide from "./TraderDetailRightSide";
import TraderDetailLeftSide from "./TraderDetailLeftSide";

const TraderDetailEvent = () => {
  return (
    <TraderDetailSection>
      <SectionWrap>
        <TraderDetailBackground />
        <TraderDetailLeftSide />
        <TraderDetailRightSide />
      </SectionWrap>
    </TraderDetailSection>
  );
};

export default React.memo(TraderDetailEvent)
